<mat-toolbar color="primary">
  <button mat-icon-button (click)="sidenav.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="title-container"><span class="title-main">Ordermate</span><span class="version">{{version}}</span></div>
  <span class="spacer"></span>
<!--  <button mat-icon-button>-->
<!--    <mat-icon>notifications</mat-icon>-->
<!--  </button>-->
  <div class="user-info">
    <span class="name">{{ authService.getUserName() }}</span>
    <span class="name">{{ authService.getTenantName() }}</span>
  </div>
  <button mat-icon-button (click)="onLogout()" *ngIf="loggedIn()">
    <mat-icon>logout</mat-icon>
  </button>
  <!--  <mat-menu #userAccountMenu [overlapTrigger]="false" yPosition="below">-->
  <!--    <button mat-menu-item routerLink="#">-->
  <!--      <mat-icon>login</mat-icon><span>My Account</span>-->
  <!--    </button>-->
  <!--    <button mat-menu-item routerLink="#">-->
  <!--      <mat-icon>settings</mat-icon><span>Settings</span>-->
  <!--    </button>-->
  <!--    <button mat-menu-item routerLink="#">-->
  <!--      <mat-icon>help</mat-icon><span>Help</span>-->
  <!--    </button>-->
  <!--    <mat-divider></mat-divider>-->
  <!--    <button mat-menu-item routerLink="#">-->
  <!--      <mat-icon>exit_to_app</mat-icon>Logout-->
  <!--    </button>-->
  <!--  </mat-menu>-->
</mat-toolbar>

<mat-sidenav-container class="app-container">
  <mat-sidenav #sidenav mode="over" [class.mat-elevation-z4]="true" class="app-sidenav">
    <mat-nav-list>
      <mat-list-item routerLink="/login" (click)="closeSidebar(sidenav)">
        <mat-icon>login</mat-icon><span>Login</span>
      </mat-list-item>
<!--      <mat-list-item routerLink="/order" (click)="closeSidebar(sidenav)" *ngIf="showItem('user')">-->
<!--        <mat-icon>restaurant</mat-icon><span>Bestellung</span>-->
<!--      </mat-list-item>-->
      <mat-list-item routerLink="/tablenumber" (click)="closeSidebar(sidenav)" *ngIf="showItem('user')">
        <mat-icon>table_bar</mat-icon><span>Tischnummer</span>
      </mat-list-item>
      <mat-list-item routerLink="/create-waiter" (click)="closeSidebar(sidenav)" *ngIf="showItem('admin')">
        <mat-icon>person_add</mat-icon><span>Kellner erstellen</span>
      </mat-list-item>
      <mat-list-item routerLink="/waiter-overview" (click)="closeSidebar(sidenav)" *ngIf="showItem('admin')">
        <mat-icon>groups</mat-icon><span>Kellnerübersicht</span>
      </mat-list-item>
      <mat-list-item routerLink="/orders-overview" (click)="closeSidebar(sidenav)" *ngIf="showItem('user')">
        <mat-icon>list_alt</mat-icon><span>Bestellübersicht</span>
      </mat-list-item>
      <mat-list-item routerLink="/receipts-overview" (click)="closeSidebar(sidenav)" *ngIf="showItem('user')">
        <mat-icon>receipt_long</mat-icon><span>Rechnungsübersicht</span>
      </mat-list-item>
      <mat-list-item routerLink="/cancel-order-overview" (click)="closeSidebar(sidenav)" *ngIf="showItem('admin')">
        <mat-icon>cancel_presentation</mat-icon><span>Stornoübersicht</span>
      </mat-list-item>
      <mat-list-item routerLink="/waiter-checkin-out" (click)="closeSidebar(sidenav)" *ngIf="showItem('admin')">
        <mat-icon>how_to_reg</mat-icon><span>Checkin-Checkout</span>
      </mat-list-item>
      <mat-list-item routerLink="/manage-categories" (click)="closeSidebar(sidenav)" *ngIf="showItem('admin')">
        <mat-icon>category</mat-icon><span>Kategorien</span>
      </mat-list-item>
      <mat-list-item routerLink="/manage-items" (click)="closeSidebar(sidenav)" *ngIf="showItem('admin')">
        <mat-icon>restaurant_menu</mat-icon><span>Menü-Übersicht</span>
      </mat-list-item>
      <mat-list-item routerLink="/manage-printer" (click)="closeSidebar(sidenav)" *ngIf="showItem('superadmin')">
        <mat-icon>print</mat-icon><span>Druckerverwaltung</span>
      </mat-list-item>
      <mat-list-item routerLink="/manage-tenants" (click)="closeSidebar(sidenav)" *ngIf="showItem('superadmin')">
        <mat-icon>festival</mat-icon><span>Tenants</span>
      </mat-list-item>
      <mat-list-item routerLink="/queue-category-assignment" (click)="closeSidebar(sidenav)" *ngIf="showItem('superadmin')">
        <mat-icon>event_list</mat-icon><span>Queue Zuordnung</span>
      </mat-list-item>
      <mat-list-item routerLink="/errors" (click)="closeSidebar(sidenav)" *ngIf="showItem('user')">
        <mat-icon>error</mat-icon><span>Fehlerübersicht</span>
      </mat-list-item>
      <!--      <mat-expansion-panel [class.mat-elevation-z0]="true">-->
      <!--        <mat-expansion-panel-header>-->
      <!--          Mobile Phone-->
      <!--        </mat-expansion-panel-header>-->
      <!--        <mat-nav-list>-->
      <!--          <a mat-list-item routerLink="#">-->
      <!--            <mat-icon>apple</mat-icon><span>iOS</span>-->
      <!--          </a>-->
      <!--          <a mat-list-item routerLink="#">-->
      <!--            <mat-icon>android</mat-icon><span>Android</span>-->
      <!--          </a>-->
      <!--        </mat-nav-list>-->
      <!--      </mat-expansion-panel>-->
      <!--      <mat-expansion-panel [class.mat-elevation-z0]="true">-->
      <!--        <mat-expansion-panel-header>-->
      <!--          Frameworks-->
      <!--        </mat-expansion-panel-header>-->
      <!--        <mat-nav-list>-->
      <!--          <a mat-list-item routerLink="#">Spring</a>-->
      <!--          <a mat-list-item routerLink="#">Hibernate</a>-->
      <!--          <a mat-list-item routerLink="#">Struts</a>-->
      <!--        </mat-nav-list>-->
      <!--      </mat-expansion-panel>-->
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
    <!--    <app-messages></app-messages>-->
  </mat-sidenav-content>
</mat-sidenav-container>


